$(document).on('turbolinks:load', function() {

  $('.assigned_task_form').on('click', '.relevance-btn', function() {

    id_attr = $(this).attr("id")
    id_attr = String(id_attr)

    // if (id_attr.includes("not_relevant") || id_attr.includes("relevant")){
    //   Rails.fire(this.form, "submit");


    // }

    var div = $('.post-review-task .overlay-div');
    div.show();

    if(id_attr.includes("not_relevant")){
      div.css("background-color", "rgba(189, 6, 0, 0.5)");
      div.find('.not-relevant').show()
    } 
    else if(id_attr.includes("relevant")) {
      div.css("background-color", "rgba(40, 173, 0, 0.5)");
      div.find('.relevant').show()
    } else {
      div.css("background-color", "rgba(128, 128, 128, 0.5)");
      div.find('.skipped').show()
    }

  });

  $('.post-review-task').on('click', '.modify-btn', function(){
    var div = $('.post-review-task .overlay-div')
    div.find('.not-relevant').hide()
    div.find('.relevant').hide()
    div.find('.skipped').hide()
    div.hide();
  })
});